const defaultApiBaseUrl = "https://api.advahini.com/api/v1";
const normalizeEnvironment = (value) => {
  const raw = String(value || "local").trim().toLowerCase().replace(/-/g, "_");
  if (raw === "dev" || raw === "develop") return "development";
  if (raw === "stage") return "staging";
  if (raw === "prod") return "production";
  return ["local", "development", "staging", "production"].includes(raw) ? raw : "local";
};

export const APP_ENV = normalizeEnvironment(
  process.env.REACT_APP_ENV || process.env.REACT_APP_ADVAHINI_ENV || process.env.NODE_ENV
);
export const IS_LOCAL_ENV = APP_ENV === "local" || APP_ENV === "development";

const getBrowserOrigin = (fallback = "http://localhost:3000") =>
  typeof window !== "undefined" && window.location?.origin ? window.location.origin : fallback;

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (IS_LOCAL_ENV ? "http://localhost:8000/api/v1" : defaultApiBaseUrl);
export const PLAYER_BASE_URL =
  process.env.REACT_APP_PLAYER_BASE_URL ||
  (IS_LOCAL_ENV ? `${getBrowserOrigin()}/player` : "https://d.advahini.com");

const deriveApiOrigin = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  try {
    return new URL(raw, typeof window !== "undefined" ? window.location.origin : defaultApiBaseUrl).origin;
  } catch {
    return "";
  }
};

const deriveHostname = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  try {
    return new URL(raw, getBrowserOrigin()).hostname;
  } catch {
    return "";
  }
};

export const PLAYER_HOSTNAME = deriveHostname(PLAYER_BASE_URL);
export const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  deriveApiOrigin(API_BASE_URL) ||
  (typeof window !== "undefined" ? window.location.origin : "http://localhost:8000");
const defaultContentCdnUrl = IS_LOCAL_ENV ? "" : "https://cdn.advahini.com";
const configuredContentCdnUrl = process.env.REACT_APP_CONTENT_CDN_URL;
export const CONTENT_CDN_URL = String(
  configuredContentCdnUrl === undefined ? defaultContentCdnUrl : configuredContentCdnUrl
)
  .trim()
  .replace(/\/+$/g, "");
export const SITE_URL = process.env.REACT_APP_SITE_URL || "http://localhost:3000";
export const CANVA_EDITOR_URL = process.env.REACT_APP_CANVA_EDITOR_URL || "";
export const CANVA_API_KEY = process.env.REACT_APP_CANVA_API_KEY || "";
